module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('my-scroll', {
    ref: "scrollRef",
    staticClass: "my-suggest-list",
    attrs: {
      "data": _vm.result,
      "beforeScroll": _vm.beforeScrollData,
      "pullup": _vm.pullup
    },
    on: {
      "beforeScroll": _vm.beforeScroll,
      "scrollToEnd": _vm.scrollToEnd
    }
  }, [_c('ul', {
    staticClass: "suggest-list"
  }, [_vm._l((_vm.result), function(item) {
    return _c('li', {
      staticClass: "suggest-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('i', {
      class: _vm.getIconCls(item)
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('p', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getSingernameOrSongname(item))
      }
    })])])
  }), _vm._v(" "), _c('MyLoading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    attrs: {
      "title": ""
    }
  })], 2), _vm._v(" "), (!_vm.hasMore && !_vm.result.length) ? _c('div', {
    staticClass: "no-result-wrapper"
  }, [_c('my-no-result')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-76550d64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/MySuggestList/MySuggestList.vue
// module id = 489
// module chunks = 9